import React from 'react'
import { Pane, Select } from 'evergreen-ui'
export const Number = ({ field }) => {
    return <Pane>
        <Select value={field.special} onChange={e => field.special = e.target.value}>
            <option value={false}>Standard</option>
            <option value="numberAPI">Number API</option>
        </Select>
    </Pane>
} 